export default value => /^[a-z0-9-]*$/.test(value)
